angular = require('angular')
app = angular.module('workflow.app')

app.constant( 'SEARCH_SCOPE',
  FOCUSED:  'search_country'
  ENHANCED: 'search_international'
  GLOBAL:   'search_global'

  DEFAULT_COUNTRY_ISO_CODE_FOR_NON_GLOBAL_SCOPE: 'us'
)
